declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		fbq?: (...args: any[]) => void;
	}
}

/*
 * Tracks a Meta Pixel CompleteRegistration event when a user completes a signature.
 * This standard event helps optimize ad conversions for completed registrations.
 */
const trackCompleteRegistration = (params?: Record<string, unknown>): void => {
	if (typeof window !== 'undefined' && window.fbq) {
		window.fbq('track', 'CompleteRegistration', params);
	}
};

export const metaPixelTracking = {
	trackCompleteRegistration,
};
